var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{staticClass:"transition-opacity transition-transform",attrs:{"enter-active-class":"duration-500","enter-class":"opacity-0","leave-active-class":"duration-200","leave-to-class":"scale-25 opacity-0"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }